import React from 'react';
import { CargaRequester } from '../../components/CargaRequester';
import { TenantSelector } from '../../components/TenantSelector';


export const DebugPage = () => {
    return <div>
        <CargaRequester />
        <TenantSelector />
    </div>;
};
